import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b466458"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "content-warp" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-warp-circle1" }, null, -1))
const _hoisted_4 = { class: "content-warp-circle1-border" }
const _hoisted_5 = { style: {"width":"819.22px","height":"819.22px"} }
const _hoisted_6 = { class: "content-warp-circle2" }
const _hoisted_7 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-warp-circle3" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content-warp-circle3-border" }, null, -1))
const _hoisted_10 = { class: "content-warp-circle4" }
const _hoisted_11 = { class: "content-warp-text" }
const _hoisted_12 = { class: "text-tips" }
const _hoisted_13 = { class: "inner" }
const _hoisted_14 = { class: "inner-r" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "triangle" }, null, -1))

import {
  svgDiseaseCoverage1,
  svgCircleDasharray
} from './svg-components/index';
import { ref, onMounted } from 'vue';
import { selfAdaption } from './hooks';

export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-disease-coverage-1',
  props: {
    optionData: {}
  },
  setup(__props: any) {

const props = __props;
let data = ref(props.optionData.split(';'));
const TaskRef = ref<HTMLDivElement>();
const ContentRef = ref<HTMLDivElement>();
const scale = ref(1);
onMounted(async () => {
  await selfAdaption(TaskRef, ContentRef, scale);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "TaskRef",
    ref: TaskRef,
    style: _normalizeStyle({
      transform: `scale(${scale.value})`,
      transformOrigin: '0 0'
    })
  }, [
    _createElementVNode("div", {
      class: "disease-coverage",
      ref_key: "ContentRef",
      ref: ContentRef
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(svgCircleDasharray), { opacitys: "0.3" })
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(), _createElementBlock("svg", _hoisted_7, [
              _createVNode(_unref(svgCircleDasharray), { opacitys: "0.5" })
            ]))
          ]),
          _hoisted_8,
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", null, [
              _createElementVNode("div", null, [
                _createVNode(_unref(svgDiseaseCoverage1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "content-warp-text-r",
                key: index,
                style: _normalizeStyle(`transform: translateY(50%) rotate(${
                (180 / _unref(data).length) * index + 180 / _unref(data).length / 2
              }deg)`)
              }, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("div", null, [
                        _createElementVNode("div", null, _toDisplayString(item), 1)
                      ])
                    ])
                  ])
                ])
              ], 4))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "content-warp-text-rs",
                key: index,
                style: _normalizeStyle(`transform: translateY(50%) rotate(${
                (180 / _unref(data).length) * index
              }deg)`)
              }, null, 4))
            }), 128))
          ])
        ])
      ])
    ], 512)
  ], 4))
}
}

})